import { FloatingPanel } from '@mews/b2b-ui';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button } from '@optimus-web/core';
import {
    Configure2FADeviceConfigContent,
    Configure2FADeviceConfigContentProps,
} from '../../Configure2FA/Configure2FADevice/Configure2FADeviceConfigContent';

interface Configure2FAPanelDeviceConfigProps extends Configure2FADeviceConfigContentProps {
    onClose: () => void;
    onSubmit: () => void;
    onReturn: () => void;
}

export function Configure2FAPanelDeviceConfig({
    onClose,
    onSubmit,
    onReturn,
    authenticator,
    isPending,
}: Configure2FAPanelDeviceConfigProps) {
    return (
        <FloatingPanel
            modal
            size="small"
            active
            onClose={onClose}
            title={<LocalizedText textKey={TextKey.AuthenticatorGetCodes} />}
            footer={{
                primary: (
                    <Button size="medium" variant="primary" onClick={onSubmit} type="submit">
                        <LocalizedText textKey={TextKey.Next} />
                    </Button>
                ),
                secondary: (
                    <Button onClick={onReturn} size="medium" type="submit">
                        <LocalizedText textKey={TextKey.GoBack} />
                    </Button>
                ),
            }}
        >
            <Configure2FADeviceConfigContent authenticator={authenticator} isPending={isPending} />
        </FloatingPanel>
    );
}
